<footer class="p-footer">
  <span>© 2021 中租控股股份有限公司 <br class="break-point">Chailease Holding Company Limited. All Right Reserved.</span>
</footer>
